// Adds a class to hide personal/sensitive info from LogRocket and/or similar recording tools
import { isPersonalCompany } from '@app/adapters/silverfin'

export default function useRedactSessionRecording(
  shouldHideIfPersonalCompany: boolean = true,
  shouldHideIfPulse: boolean = false
): string {
  const currentCompanyId = window.Silverfin?.currentCompanyId
  const isPulseUser = window.Silverfin?.isCurrentUserPulse()

  const shouldHideForCompany =
    shouldHideIfPersonalCompany &&
    currentCompanyId &&
    isPersonalCompany(currentCompanyId)
  const shouldHideForPulse = shouldHideIfPulse && isPulseUser

  const hide = shouldHideForCompany || shouldHideForPulse

  return hide ? 'elements-should-be-redacted' : ''
}
